import React from 'react'
import { Routes, Route } from 'react-router-dom';
import List from './List';
import Details from './Details';
import AddEdit from './AddEdit';
import Statistics from './Statistics';
import BulkActions from './BulkActions';
import AvailablePostmark from './AvailablePostmark';
import AutoAssign from './AutoAssign';
import Verify from './Verify';

export default function EmailTemplateRoutes() {
  return (
    <Routes>
  <Route path="/" element={<List />} />
  <Route path="details/:id" element={<Details />} />
  <Route path="new" element={<AddEdit />} />
  <Route path="edit/:id" element={<AddEdit />} />
  <Route path="statistics" element={<Statistics />} />
  <Route path="bulk" element={<BulkActions />} />
  <Route path="available-postmark" element={<AvailablePostmark />} />
  <Route path="auto-assign" element={<AutoAssign />} />
  <Route path="verify/:id" element={<Verify />} />
    </Routes>
  );
}
